import React, { Component, PropTypes } from 'react';
import { mixin, RefluxMixin, Authorizer } from 'Util';
import BundleActions from 'actions/Bundle';
import CourseActions from 'actions/Course';
import {
  List,
  ListItem,
  Styles,
  Toolbar,
  ToolbarGroup,
  ToolbarTitle,
  IconButton,
  FontIcon,
  CircularProgress,
  Dialog,
  FlatButton,
  RaisedButton,
  TextField,
  Toggle,
  DatePicker,
  RadioButtonGroup,
  RadioButton
} from 'material-ui';
import SimpleOverview from 'components/Widgets/SimpleOverview';

import { FormattedMessage, FormattedDate } from 'react-intl';
import Message from 'services/Message';
import CourseStore from 'stores/Course';
import FileUpload from 'components/Widgets/FileUpload';
import * as SvgIcons from 'components/Material/SvgIcons';
import ToolbarIconButton from 'components/Material/ToolbarIconButton';
import Cover from 'components/Material/Cover';
import ScrollableContainer from 'components/ScrollableContainer';
import DialogPortal from 'components/DialogPortal';
import CourseSelector from 'components/CourseSelector';
import Loader from 'components/Material/Loader';
import { TagSelector } from 'components/Tags';
import Overview from 'components/Widgets/Overview';

let {
  ImageImage,
  EditorModeEdit,
  ContentAdd,
  ActionDelete,
  ContentClear,
  ActionLabel
} = SvgIcons;
let { Spacing } = Styles;

export default class BundleForm extends mixin(
  RefluxMixin,
  Authorizer,
  Component
) {
  state = {
    nameEditActive: false,
    newName: '',
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func,
    muiTheme: PropTypes.object
  };

  listenToStores() {
    this.listenToStore(CourseStore, 'course');
  }

  listenToActions() {
    this.listenToAction(BundleActions.removeComplete, bundle => {
      Message.info(this.context.getIntlMessage('bundle.removed'));
    });

    this.listenToAction(BundleActions.removeError, errorMessage => {
      this.onError(errorMessage);
      this.refs.confirmDialog.dismiss();
    });
  }

  componentWillReceiveProps(nextProps) {
    // console.log(this.props.bundle, nextProps.bundle);
    if (this.props.bundle && !nextProps.bundle) {
      this.closeDetail();
    }
  }

  onError(errorMessage) {
    Message.info(errorMessage);
  }

  closeDetail() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  selectCourse(selectedCourses) {
    this.props.bundle.courses = Object.keys(selectedCourses).map(courseId => {
      return { id: courseId, name: selectedCourses[courseId] };
    });
    this.setState({ bundle: this.props.bundle });
  }

  confirmDelete(bundle) {
    BundleActions.remove(bundle);
    this.refs.confirmDialog.dismiss();
  }

  deleteBundle() {
    this.refs.confirmDialog.show();
  }

  addCourses() {
    CourseActions.filter();
    this.refs.addCoursesDialog.show();
  }

  closeCourseSelection() {
    let courses = Object.keys(this.refs.courseSelector.getSelected()).map(id =>
      parseInt(id, 10)
    );
    if (courses.length > 0) {
      this.props.bundle.courses.forEach(course => {
        courses.push(parseInt(course.id, 10));
      });
      BundleActions.update(parseInt(this.props.bundle.id, 10), { courses });
      Message.info(this.context.getIntlMessage('bundle.updated'));
    }
    this.refs.addCoursesDialog.dismiss();
  }

  handleUpload(data) {
    let response,
      { file } = data.pop();
    if (file.id) {
      BundleActions.update(parseInt(this.props.bundle.id, 10), {
        fileId: file.id
      });
    }
  }

  removeCourse(course) {
    this._courseToRemove = course;
    this.refs.confirmRemoveCourseDialog.show();
  }

  confirmCourseRemove() {
    let courses = [];
    this.props.bundle.courses.forEach(course => {
      if (course.id !== this._courseToRemove.id) {
        courses.push(parseInt(course.id, 10));
      }
    });
    BundleActions.update(parseInt(this.props.bundle.id, 10), { courses });
    this.refs.confirmRemoveCourseDialog.dismiss();
    Message.info(this.context.getIntlMessage('bundle.removedCourse'));
    delete this._courseToRemove;
  }

  addTag = tagName => {
    BundleActions.addTag(this.props.bundle.id, tagName);
  };

  deleteTag = tagName => {
    BundleActions.removeTag(this.props.bundle.id, tagName);
  };

  handleNameEditActive = (nameEditActive) => {
    this.setState({ nameEditActive });
  }

  handleNameEdit = (e) => {
    this.setState({ newName: e.target.value });
  }

  handleNameSave = () => {
    if (this.state.newName === '' ||
        this.state.newName === this.props.bundle.name) {
      return;
    }

    BundleActions.update(parseInt(this.props.bundle.id, 10), {
      name: this.state.newName
    });
    this.handleNameEditActive(false)
  }

  renderName = () => {
    const { nameEditActive } = this.state;
    const bundle = this.props.bundle;
    if (!bundle) { return <Loader /> }

    if (nameEditActive) {
      return (
        <div>
          <TextField
            ref="noteText"
            defaultValue={bundle.name}
            onChange={this.handleNameEdit}
            style={{marginLeft: 30}}
          />
          <RaisedButton
            onClick={this.handleNameSave}
            label="Save"
            style={{marginLeft: 10}}
          />
        </div>
      );
    }

    return (
      <div
        onClick={() => this.handleNameEditActive(true)}
      >
        <ListItem
          disabled={true}
          leftIcon={<ActionLabel />}
          primaryText={bundle.name}
        />
      </div>
    )
  }

  render() {
    let bundle = this.props.bundle;
    if (!bundle) {
      return <Loader />;
    }
    const existingCourses = bundle.courses.map(course => course.id);

    let confirmActions = [
      { text: 'Cancel' },
      {
        text: 'Submit',
        onTouchTap: this.confirmDelete.bind(this, bundle),
        ref: 'submit'
      }
    ];
    let confirmCourseRemoveActions = [
      { text: 'Cancel' },
      {
        text: 'Submit',
        onTouchTap: this.confirmCourseRemove.bind(this),
        ref: 'submit'
      }
    ];
    let courseActions = [
      <FlatButton
        key="ok"
        label={this.context.getIntlMessage('OK')}
        secondary={true}
        className="full"
        onTouchTap={this.closeCourseSelection.bind(this)}
      />
    ];
    let coverImage = bundle.coverImage;
    let backgroundImage =
      coverImage && coverImage.length > 0 && coverImage[0] && coverImage[0].url;
    let toolbar = (
      <Toolbar>
        <ToolbarGroup float={'left'} key={0}>
          <ToolbarTitle text={this.context.getIntlMessage('Bundle')} />
        </ToolbarGroup>
        <ToolbarGroup float={'right'} key={1}>
          <FileUpload
            onSuccess={this.handleUpload.bind(this)}
            Element={ToolbarIconButton}
            svgIcon={<ImageImage />}
            secondary={true}
          />
          <ToolbarIconButton
            svgIcon={<ContentAdd />}
            onTouchTap={::this.addCourses}
          />
          <ToolbarIconButton
            svgIcon={<ActionDelete />}
            onTouchTap={::this.deleteBundle}
          />
          <ToolbarIconButton
            svgIcon={<ContentClear />}
            onTouchTap={::this.closeDetail}
          />
        </ToolbarGroup>
      </Toolbar>
    );

    return (
      <ScrollableContainer header={toolbar} card>
        <Cover responsive={false} size={1920} image={backgroundImage} />
        <List>
          {this.renderName()}
        </List>
        <Overview header={this.context.getIntlMessage('course.properties')}>
          <TagSelector
            onAddTag={this.addTag}
            onRemoveTag={this.deleteTag}
            tags={bundle.tagsMap}
            fullWidth
            padded
          />
        </Overview>
        <SimpleOverview
          items={bundle.courses}
          readable="name"
          title={this.context.getIntlMessage('course.Courses')}
          onTouchTapRightIcon={this.removeCourse.bind(this)}
        />
        <DialogPortal>
          <Dialog
            ref="addCoursesDialog"
            // title={<h3 className='mui-dialog-title'>{this.context.getIntlMessage('Choose Courses')}</h3>}
            title={this.context.getIntlMessage('course.choose')}
            actions={courseActions}
            autoDetectWindowHeight={true}
            autoScrollBodyContent={true}
            dismissOnClickAway={true}
          >
            <CourseSelector ref="courseSelector" ignoreExistingCourses={existingCourses} />
          </Dialog>
          <Dialog
            ref="confirmDialog"
            title={this.context.getIntlMessage('bundle.remove')}
            actions={confirmActions}
            actionFocus="submit"
            dismissOnClickAway={true}
          >
            <FormattedMessage
              message={this.context.getIntlMessage('bundle.removeBundle')}
              bundle={bundle.code}
            />
          </Dialog>
          <Dialog
            ref="confirmRemoveCourseDialog"
            title={this.context.getIntlMessage('bundle.removeCourse')}
            actions={confirmCourseRemoveActions}
            actionFocus="submit"
            dismissOnClickAway={true}
          >
            {this.context.getIntlMessage('bundle.removeCourseConfirm')}
          </Dialog>
        </DialogPortal>
      </ScrollableContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Bundle/Detail.js